export default __webpack_public_path__ + "static/media/23.81a4c819.jpg";